import React, { useState, useEffect } from 'react';
import DownloadBlock from '../shared/DownloadBlock';
import bannerImage from '../../assets/images/trusted-banner.png';
import ga4Events from '../../ga4Events';
import trustedImage from '../../assets/images/trusted.png';

function Aboutus() {
  const [counts, setCounts] = useState({
    download: 5,
    reviews: 4,
    countries: 0,
    stories: 10,
  });

  useEffect(() => {
    const updateCounter = () => {
      const targetCounts = {
        download: 15,
        reviews: 10,
        countries: 150,
        stories: 100,
      };

      const duration = 1500;
      const stepSize = 10;
      const steps = duration / stepSize;

      Object.keys(targetCounts).forEach((key) => {
        const targetCount = targetCounts[key];
        const currentCount = counts[key];
        const step = Math.ceil((targetCount - currentCount) / steps);

        if (step !== 0) {
          const interval = setInterval(() => {
            setCounts((prevCounts) => ({
              ...prevCounts,
              [key]: prevCounts[key] + step,
            }));
          }, stepSize);

          setTimeout(() => {
            clearInterval(interval);
            setCounts((prevCounts) => ({
              ...prevCounts,
              [key]: targetCount,
            }));
          }, duration);
        }
      });
    };

    updateCounter();
  }, []);

  const [ytshow, setytShow] = useState(false);

  return (
    <>
      <section className="about_section row_am">
        <div className="anchor" id="approved_kids" />
        <div className="container">
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
            <span className="title_badge mb-1">Trusted & Verified</span>
            <h2>
              <span>Trusted</span> by Families
            </h2>
            <h2>
              <span>Approved</span> for Kids
            </h2>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <ul className="app_statstic" id="counter" data-aos="fade-in" data-aos-duration={1500} data-aos-once>
                <li data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                  <div className="text">
                    <p>
                      <span className="counter-value">{counts.download}</span>
                      <span>K+</span>
                    </p>
                    <p>Download</p>
                  </div>
                </li>
                <li data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                  <div className="text">
                    <p>
                      <span className="counter-value">{counts.stories}</span>
                      <span>+</span>
                    </p>
                    <p>Stories</p>
                  </div>
                </li>
                <li data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                  <div className="text">
                    <p>
                      <span className="counter-value">{counts.countries}</span>
                      <span>+</span>
                    </p>
                    <p>Countries</p>
                  </div>
                </li>
                <li data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                  <div className="text">
                    <p>
                      <span className="counter-value">{counts.reviews}</span>
                      <span>K+</span>
                    </p>
                    <p>Happy Children</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="abtImg text-center" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <img src={bannerImage} alt="image" className="about_image" />
              </div>
            </div>
            <div className="col-lg-4">
              <p data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                FairyTaler is designed for children and families, with content made to be age-appropriate, safe, and
                easy to enjoy. Reviewed for Apple’s Kids category and built with guidance from professional teachers,
                it’s a trusted app for personalized stories, songs, and calming bedtime moments.
              </p>
              <div className="trusted_image" data-aos="fade-up" data-aos-duration={1500} data-aos-once>
                <img src={trustedImage} alt="image" />
              </div>
              <DownloadBlock section="about_us" />
            </div>
          </div>
        </div>
      </section>

      {ytshow && (
        <div
          className="modal fade youtube-video show"
          id="myModal"
          tabIndex={-1}
          style={{ display: 'block', paddingRight: 17 }}
          aria-modal="true"
          role="dialog"
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              onClick={() => {
                setytShow(false);
                ga4Events.aboutUs.videoModalCloseClick();
              }}
            >
              <button
                id="close-video"
                type="button"
                className="button btn btn-default text-right"
                data-dismiss="modal"
                onClick={(e) => {
                  e.stopPropagation();
                  setytShow(false);
                  ga4Events.aboutUs.videoModalCloseClick();
                }}
              >
                <i className="icofont-close-line-circled" />
              </button>
              <div className="modal-body">
                <div id="video-container" className="video-container">
                  <iframe
                    id="youtubevideo"
                    width={640}
                    height={360}
                    allowFullScreen=""
                    src="https://www.youtube.com/embed/If2-kDjS8UI?autoplay=1"
                  />
                </div>
              </div>
              <div className="modal-footer"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Aboutus;
